// Match the detailed reference plan's resolution without letting PDF print size
// determine recognition cost. Both source formats use the same pixel budget.
export function floorplanRasterScale(width: number, height: number) {
  return Math.min(
    3400 / width,
    3400 / height,
    Math.sqrt(8_000_000 / (width * height))
  );
}
